import { EmailDraftV2, FormValues } from './composeEmailModal.types';

/** Convert FormValues to EmailDraftV2 for saving to server storage. */
export const convertFormValuesToEmailDraftV2 = (
  values: FormValues,
  timestamp: number,
): EmailDraftV2 => {
  const { includeInternalNote: _, ...rest } = values;
  return { ...rest, timestamp };
};

/**
 * Convert EmailDraftV2 from server storage to FormValues for pre-populating the
 * form.
 */
export const convertEmailDraftV2ToFormValues = (
  draft: EmailDraftV2,
): Partial<FormValues> => ({
  ...draft,
  includeInternalNote: draft.internalNote.length > 0,
  customAttributesOpen:
    draft.customAttributesOpen ||
    Object.keys(draft.customAttributes ?? {}).length > 0,
});
